import './ViewSelector.scss';
import { createAsyncSelectors } from '@lib/selectors';
import { PaginationDirection } from '@sonar-software/sonar-ts-types';
import { ViewLabel } from './ViewLabel';
import { COPY_SPECIFIC, DEFAULT_FILTER } from '@sonar-software/sonar-ts-constants';
import { coreActions } from '@sonar-software/sonar-core';
import { CreateView } from './CreateView';
import React, { useEffect, useMemo } from 'react';
import Select from 'antd/es/select/index';
import { useAction, useAsyncState } from '@hooks';
function buildOptions(views, queryParams) {
    var _a;
    const viewOptions = (_a = views === null || views === void 0 ? void 0 : views.map((view) => ({
        label: React.createElement(ViewLabel, { key: view.id, queryParams: queryParams, view: view }),
        title: view.name,
        value: view.id
    }))) !== null && _a !== void 0 ? _a : [];
    viewOptions.unshift({
        label: COPY_SPECIFIC.DEFAULT_VIEW,
        value: 0
    });
    return viewOptions;
}
const viewsSelectors = createAsyncSelectors((state) => state.core.dataDictionary.views.get);
export const ViewSelector = ({ queryParams, updateQuery }) => {
    var _a, _b;
    const { data, isRequested } = useAsyncState(viewsSelectors);
    const loadViews = useAction(coreActions.requestGetCoreDataDictionaryViews);
    useEffect(() => {
        if (queryParams.sonarObjectId ||
            queryParams.sonarObjectType ||
            queryParams.tagId ||
            queryParams.applicationId ||
            Number.isInteger(queryParams.complianceCategory)) {
            loadViews({
                applicationId: queryParams.applicationId,
                complianceCategory: queryParams.complianceCategory,
                sonarObjectId: queryParams.sonarObjectId,
                sonarObjectType: queryParams.sonarObjectType,
                tagId: queryParams.tagId
            });
        }
    }, [
        loadViews,
        queryParams.applicationId,
        queryParams.sonarObjectId,
        queryParams.sonarObjectType,
        queryParams.tagId,
        queryParams.complianceCategory
    ]);
    useEffect(() => {
        if (data && queryParams.lastViewId && !data.results.find((entry) => entry.id === queryParams.lastViewId)) {
            updateQuery({
                lastViewId: undefined,
                viewName: undefined,
                viewSkip: true
            });
        }
    }, [data, queryParams.lastViewId, updateQuery]);
    const options = useMemo(() => buildOptions(data === null || data === void 0 ? void 0 : data.results, queryParams), [data === null || data === void 0 ? void 0 : data.results, queryParams]);
    if (!queryParams || (!queryParams.sonarObjectId &&
        !queryParams.sonarObjectType &&
        !queryParams.applicationId &&
        !queryParams.tagId &&
        !Number.isInteger(queryParams.complianceCategory))) {
        return null;
    }
    const createView = React.createElement(CreateView, { onFinish: (viewId, viewName) => {
            updateQuery({
                lastViewId: viewId,
                viewName
            });
        }, queryParams: queryParams });
    return (React.createElement(Select, { className: 'view-selector', dropdownRender: (menu) => React.createElement(React.Fragment, null,
            menu,
            createView), labelRender: (props) => { var _a; return (isRequested ? (_a = queryParams.viewName) !== null && _a !== void 0 ? _a : '' : props.label); }, loading: isRequested, onSelect: (value, option) => {
            updateQuery({
                columns: '',
                filters: value ? '' : DEFAULT_FILTER,
                key: '',
                lastViewId: undefined,
                ordering: '',
                paginationDirection: PaginationDirection.Forward,
                viewId: value || undefined,
                viewName: option.title
            });
        }, options: options, popupClassName: 'view-selector-dropdown', popupMatchSelectWidth: false, size: 'large', value: (_b = (_a = queryParams.viewId) !== null && _a !== void 0 ? _a : queryParams.lastViewId) !== null && _b !== void 0 ? _b : 0 }));
};
